import { MapPin } from "lucide-react";
import { useLang } from "@/i18n";
import { COLLECTION_IMAGES } from "@/data";
import { Reveal, Kicker } from "@/components/Reveal";

const Collections = () => {
  const { t } = useLang();
  return (
    <section id="collections" className="relative py-24 sm:py-32 scroll-mt-20" data-testid="collections-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <Reveal className="max-w-3xl">
          <Kicker>{t.collections.kicker}</Kicker>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-slate-50">
            {t.collections.title}
          </h2>
          <p className="mt-6 text-base sm:text-lg text-slate-400 leading-relaxed">{t.collections.sub}</p>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-2 gap-6 lg:gap-8">
          {t.collections.items.map((c, i) => (
            <Reveal key={c.name} delay={(i % 2) * 0.12}>
              <div
                data-testid={`collection-card-${i}`}
                className="group relative h-[420px] overflow-hidden rounded-2xl ring-1 ring-gold/15 hover:ring-gold/50 transition-all duration-500"
              >
                <img
                  src={COLLECTION_IMAGES[i]}
                  alt={c.name}
                  className="absolute inset-0 h-full w-full object-cover group-hover:scale-110 transition-transform duration-[1.6s] ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B0C10] via-[#0B0C10]/45 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-8">
                  <h3 className="font-display text-2xl sm:text-3xl text-slate-50">{c.name}</h3>
                  <p className="mt-2 text-sm sm:text-base text-slate-300 max-w-md">{c.desc}</p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {c.points.map((p) => (
                      <span key={p} className="inline-flex items-center gap-1.5 rounded-full bg-[#0B0C10]/70 backdrop-blur px-3 py-1.5 text-xs text-gold-light ring-1 ring-gold/30">
                        <MapPin size={11} />
                        {p}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Collections;
